import { render, staticRenderFns } from "./FieldCodePortal.vue?vue&type=template&id=6bdceb83&"
import script from "./FieldCodePortal.vue?vue&type=script&lang=js&"
export * from "./FieldCodePortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports